import React, { useState } from 'react';
export const WaitlistForm = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      alert('Please enter your email address to join the waitlist.');
      return;
    }
    setIsLoading(true);
    try {
      await fetch('https://hooks.zapier.com/hooks/catch/23169540/2v9ovop/', {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          timestamp: new Date().toISOString(),
          source: 'kraya_waitlist',
          triggered_from: window.location.href
        })
      });
    } catch {
      // fire-and-forget — show success regardless
    }
    setEmail('');
    setIsLoading(false);
    setIsSubmitted(true);
  };
  if (isSubmitted) {
    return <div className="w-full text-center" data-id="element-141">
        <p className="text-gray-900 font-semibold text-sm" data-id="element-142">
          🎉 You're on the waitlist!
        </p>
        <p className="text-gray-600 text-xs mt-1" data-id="element-143">
          We'll notify you when we launch.
        </p>
      </div>;
  }
  return <div className="w-full" data-id="element-144">
      <form onSubmit={handleSubmit} className="w-full" data-id="element-145">
        <div className="flex flex-col gap-3" data-id="element-146">
          <input type="email" placeholder="Email Address" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-5 py-2.5 text-sm rounded-full bg-white/30 border border-white/40 text-gray-900 placeholder-gray-500 backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-yellow-400/50 transition-all" data-id="element-147" />
          <button type="submit" disabled={isLoading} className="w-full px-5 py-2.5 text-sm bg-black text-white rounded-full hover:bg-gray-900 transition-colors font-semibold shadow-lg disabled:opacity-70" data-id="element-148">
            {isLoading ? 'Joining...' : 'Submit'}
          </button>
        </div>
      </form>
    </div>;
};